import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import api from "api/axiosConfig";
import API_BASE from "configs/hostConfig";
import {
  Box,
  Flex,
  Heading,
  Text,
  VStack,
  HStack,
  Button,
  Badge,
  useColorModeValue,
  useToast,
} from '@chakra-ui/react';
import theme from 'ui/theme/theme';
import { TbAlertCircle } from 'react-icons/tb';

function PlanCard({
  name,
  price,
  originalPrice,
  priceId,
  details,
  isFree,
  isMostPopular,
  user,
}) {
  const navigate = useNavigate();
  const toast = useToast();
  const cardBg = useColorModeValue('white', 'gray.800');
  const cardBorder = isMostPopular ? '2px solid teal' : '1px solid gray';

  // console.log('user: ', user);

  function toastMessage(msg) {
    toast({
      position: 'top',
      render: () => (
        <Box
          border="1px solid"
          // color={theme.colors.semantics['warning-light']}
          borderColor={theme.colors.semantics.warning}
          p={4}
          bg={theme.colors.semantics['warning-light']}
          borderRadius={12}
          wordBreak="break-all"
        >
          <Flex>
            <TbAlertCircle color={theme.colors.semantics.warning} />
            <Flex ml="12px" flex="1">
              <Text fontWeight="bold" ml="2">
                {msg}
              </Text>
            </Flex>
          </Flex>
        </Box>
      ),
      duration: 5000,
    });
  }

  const handleSubscribe = () => {
    const body = {
      priceId,
      interval: name,
      description: name,
    };
    // console.log('stripe session body: ', body);
    if (!user) {
      toastMessage(
        "Oops! It looks like you're not logged in yet. Please sign in to the system to subscribe to your selected plan."
      );
      return;
    }
    try {
      api.post(`${API_BASE}/api/payment/session-subscription`, body).then((res) => {
        // console.log('session response: ', res);
        if (res.status == 200) {
          window.location.href = res.data?.data?.sessionUrl;
        }
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  return (
    <Flex
      direction="column"
      justify="space-between"
      w="100%"
      maxW="md"
      p={6}
      borderWidth="1px"
      borderColor={cardBorder}
      borderRadius="md"
      boxShadow="md"
      bg={cardBg}
      textAlign="center"
      h="100%"
    >
      <Box>
        {isMostPopular && (
          <Badge colorScheme="teal" mb={4}>
            Most Popular
          </Badge>
        )}
        <Heading size="md" mb={2}>
          {name}
        </Heading>
        <HStack justify="center" mb={4}>
          <Text fontSize="2xl" fontWeight="bold">
            ${price || originalPrice}
          </Text>
          {price && (
            <Text as="s" color="gray.500" fontSize="lg">
              ${originalPrice}
            </Text>
          )}
        </HStack>
        <VStack spacing={3} align="start" mb={6}>
          {details.map((detail, index) => (
            <Text key={index}>- {detail}</Text>
          ))}
        </VStack>
      </Box>
      {isFree ? (
        <Button
          colorScheme="green"
          size="lg"
          isDisabled={user?.userId ? true : false}
          onClick={() => navigate('/signup')}
        >
          Sign Up
        </Button>
      ) : (
        <Button colorScheme="green" size="lg" onClick={handleSubscribe}>
          Choose Plan
        </Button>
      )}
    </Flex>
  );
}

PlanCard.propTypes = {
  name: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  originalPrice: PropTypes.string,
  priceId: PropTypes.string.isRequired,
  details: PropTypes.string.isRequired,
  isFree: PropTypes.bool,
  isMostPopular: PropTypes.bool,
  user: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool,
      PropTypes.arrayOf(PropTypes.string),
    ])
  ),
};

export default PlanCard;
